<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import { usePageStore } from '../../../stores/page'
import { useFlickitySlider } from '../../../composables/use-flickity-slider'

import type { SliderOptions } from '@xcel-next/rendering-tools'

const props = defineProps<{
  sliderOptions?: SliderOptions
}>()

const { pageData } = storeToRefs(usePageStore())

const flickityDiv = ref<HTMLElement | null>(null)
const { sliderSettings, sliderControlDescription, initFlickitySlider, keepTabbingFocusInSlider } = useFlickitySlider(flickityDiv)

const blockedForPage = computed(() => ['/support', '/newsletter'].includes(pageData.value?.pageMeta?.url ?? ''))

onMounted(async () => {
  if (!blockedForPage.value) {
    await initFlickitySlider(props.sliderOptions)
  }
})
</script>

<template>
  <div v-if="!blockedForPage"
       id="starsign-slider-flickity-0"
       ref="flickityDiv"
       class="bx-slider bx-slider--starsign-slider bx-typo--starsign-slider"
       :aria-label="`Sternzeichen Karusell: ${sliderSettings?.starsignSlider?.items.length} Inhalte. ${sliderControlDescription}`"
       @keydown.enter="keepTabbingFocusInSlider()">
    <div v-for="(item, index) in sliderSettings?.starsignSlider?.items"
         :id="`bx-js-starsign-slider-cell-${index}`"
         :key="index"
         class="bx-slider__cell">
      <a :href="item.url"
         :title="item.name"
         tabindex="-1">
        <svg><use :href="`#${item.name.toLowerCase()}`" /></svg>
        <span>{{ item.name }}</span>
      </a>
    </div>
  </div>
</template>
